// extracted by mini-css-extract-plugin
export var container = "bF_b";
export var feature = "bF_cd";
export var featureText = "bF_cf";
export var features = "bF_cb";
export var footer = "bF_ch";
export var footerText = "bF_cj";
export var icon = "bF_bv";
export var section = "bF_d";
export var text = "bF_b6";
export var title = "bF_h";
export var waveOne = "bF_q";
export var waveThree = "bF_b5";
export var waveTwo = "bF_n";
export var waves = "bF_b4";